// extracted by mini-css-extract-plugin
export default {"children":"about_children__YqoZs"};